import { defineChain } from "viem";

export const localhost1337 = defineChain({
  id: 10001,
  name: "ETHW",
  nativeCurrency: { name: "ETHW", symbol: "ETHW", decimals: 18 },
  rpcUrls: { default: { http: ["https://mainnet.ethereumpow.org"] } },
});
